import React from 'react';
import { CGE } from '../../../../common/components/CGE';
import EnergyReconversionContextProvider, {
    EnergyReconversionContext,
    ACTIONS
} from "../../context/EnergyReconversionContextProvider";
import Loading from "../../../../common/components/Loading";
import { beforeMaskedValueChangeRut, decode_utf8,isRutValid,transformId,urlParams } from '../../../../common/utils/utilsFunc'
import { useModal } from "@clayui/modal";
import { TOKEN_CAPTCHA_COOKIE_KEY } from "../../../../common/utils/cookiesUtil";
import useCookie from '../../../../common/hooks/useCookie';


const EnergyReconversion = ({ props }) => {

    const [state, dispatch] = React.useContext(EnergyReconversionContext);
    const [values, setValues] = React.useState({});
    const [idClient, setIdClient] = React.useState('')
    const [inputValidate, setInputValidate] = React.useState({});
    const [loading, setLoading] = React.useState(false)
    const [verifReCaptcha, setVerifReCaptcha] = React.useState(false);
    const [detailClientJson, setDetailClientJson] = React.useState([]);
    const [options, setOptions] = React.useState([]);
    const [valueOption, setValueOption] = React.useState();
    const [visibleModal, setVisibleModal] = React.useState(false);
    const { observer, onClose } = useModal({
        onClose: () => {
            setVisibleModal(false);
        },
    });
    const { updateCookieState } = useCookie(TOKEN_CAPTCHA_COOKIE_KEY);

    let propsLabelInfoContent = {
        "content": state?.webContentTextInfo,
        "observer": observer,
        "onClose": onClose,
        "setVisibleModal": setVisibleModal,
        "status": "info",
        "titleModal": "Información",
        "visibleModal": visibleModal,
        "titleHint": "Ayuda Nro de Cliente",
    }

    function validateForms() {
        let errors = {
            empty: {},
            error: {},
            msg: {}
        };

        if (values.numberClient) {
            errors.empty.numberClient = false;
        } else {
            errors.empty.numberClient = true;
            errors.msg.numberClient = "Debes ingresar un número de cliente";
            props.setGlobalAlert("Complete todos los campos obligatorios.","warning");
        }

        if (values.comuna) {
            errors.empty.comuna = false;
        } else {
            errors.empty.comuna = true;
            errors.msg.comuna = "Debes realizar la búsqueda del número de cliente. Debes tener una comuna del servicio";
            props.setGlobalAlert("Complete todos los campos obligatorios.","warning");
        }



        if (values.rut) {
            errors.empty.rut = false;

            if (!isRutValid(values.rut)) {
                errors.error.rut = true;
                errors.msg.rut = "Debes ingresar un RUT válido.";
                props.setGlobalAlert("Complete todos los campos obligatorios.","warning");

            } else {
                errors.error.rut = false;
            }

        } else {
            errors.empty.rut = true;
            errors.msg.rut = "Debes ingresar el Número de carnet  de identidad o RUT";
            props.setGlobalAlert("Complete todos los campos obligatorios.","warning");
        }

        if (values.name) {
            errors.empty.name = false;
        } else {
            errors.empty.name = true;
            errors.msg.name = "Debes ingresar el nombre del solicitante";
            props.setGlobalAlert("Complete todos los campos obligatorios.","warning");
        }

        if (values.nameFather) {
            errors.empty.nameFather = false;
        } else {
            errors.empty.nameFather = true;
            errors.msg.nameFather = "Debes ingresar el apellido paterno del solicitante";
            props.setGlobalAlert("Complete todos los campos obligatorios.","warning");
        }

        if (values.nameMother) {
            errors.empty.nameMother = false;
        } else {
            errors.empty.nameMother = true;
            errors.msg.nameMother = "Debes ingresar el apellido materno del solicitante";
            props.setGlobalAlert("Complete todos los campos obligatorios.","warning");
        }

        if (values.email) {
            errors.empty.email = false;
            if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(values.email)) {
                errors.error.email = true;
                errors.msg.email = "Debes ingresar un email válido";
                props.setGlobalAlert("Complete todos los campos obligatorios.","warning");

            } else {
                errors.error.email = false;
            }

        } else {
            errors.empty.email = true;
            errors.msg.email = "Debes ingresar el email del solicitante";
            props.setGlobalAlert("Complete todos los campos obligatorios.","warning");
        }

        if (values.cel) {
            errors.empty.cel = false;

            if (values.cel.length > 9) {
                errors.error.cel = true;
                errors.msg.cel = "No puede superar los 9 dígitos en el telefono";
                props.setGlobalAlert("Complete todos los campos obligatorios.","warning");

            } else if (values.cel.length < 9) {
                errors.error.cel = true;
                errors.msg.cel = "No puede ser inferior a los 9 dígitos en el telefono";
                props.setGlobalAlert("Complete todos los campos obligatorios.","warning");


            } else {
                errors.error.cel = false;

            }

        } else {
            errors.empty.cel = true;
            errors.msg.cel = "Debes ingresar el teléfono del solicitante";
            props.setGlobalAlert("Complete todos los campos obligatorios.","warning");
        }

        if (values.desc_1) {
            errors.empty.desc_1 = false;

        } else {
            errors.empty.desc_1 = true;
            errors.msg.desc_1 = "Debes ingresar los equipos eléctricos";
            props.setGlobalAlert("Complete todos los campos obligatorios.","warning");
        }

        if (values.desc_2) {
            errors.empty.desc_2 = false;

        } else {
            errors.empty.desc_2 = true;
            errors.msg.desc_2 = "Debes ingresar la potencia total requerida en KW";
            props.setGlobalAlert("Complete todos los campos obligatorios.","warning");
        }

        if (values.selectOptions) {
            errors.empty.selectOptions = false;

        } else {
            errors.empty.selectOptions = true;
            errors.msg.selectOptions = "Debes seleccionar si tu vivienda cuenta  con un sistema de medición independiente";
            props.setGlobalAlert("Complete todos los campos obligatorios.","warning");
        }

        if (values.checkbox) {
            errors.empty.checkbox = false;

        } else {
            errors.empty.checkbox = true;
            errors.msg.checkbox = "Debes aceptar los términos y condiciones";
            props.setGlobalAlert("Complete todos los campos obligatorios.","warning");
        }

        if (verifReCaptcha) {
            errors.empty.verifReCaptcha = false;

        } else {
            errors.empty.verifReCaptcha = true;
            errors.msg.verifReCaptcha = "Falta validar que no eres un robot";
            props.setGlobalAlert("Complete todos los campos obligatorios.","warning");
        }
        setInputValidate(errors);
        return errors;
    }

    function funcSend() {
        const verifError = validateForms();
        if (transformId(state.idClientAux) !== transformId(values.numberClient)) {
            props.setGlobalAlert("Debes realizar la búsqueda del número de cliente.","warning");
        } else if(Object.values(verifError?.msg).length === 0) {
            setLoading(true)
            dispatch({
                type: ACTIONS.SET_FORM_DATA,
                payload: [values,detailClientJson]
        })
        }
    }

    React.useEffect(() => {
        const objResponse = state.responseFormData
        setLoading(false);
        if(objResponse) {
            if(objResponse?.code !== 0) {
                props.setGlobalAlert(objResponse.message,"warning", true, "Advertencia");
            } else {
                props.setGlobalAlert(objResponse.message,"success", true, "Confirmación");
                setValues({
                    numberClient: "",
                    rut: "",
                    name: "",
                    nameFather: "",
                    nameMother: "",
                    email: "",
                    cel: "",
                    desc_1: "",
                    desc_2: "",
                    selectOptions: 0,
                    checkbox: ""
                    
                });
                setDetailClientJson([]);
            }
        }
    },[state.responseFormData])

    function onChangeReCaptcha(value) {
        updateCookieState(value);
        if (value) {
            setVerifReCaptcha(true);
        }
        else {
            setVerifReCaptcha(false);
        }
    }

    function handleClickButtonClient() {
        if (values.numberClient) {
            setIdClient(values.numberClient)
        } else {

            let errors = {
                empty: {},
                error: {},
                msg: {}
            };
    
            errors.empty.numberClient = true;
            errors.msg.numberClient = "Debes ingresar un número de cliente";
            props.setGlobalAlert("Complete todos los campos obligatorios.","warning");
            
            
            setInputValidate(errors);
        }
    }

    React.useEffect(() => {
        if (idClient) {
            setLoading(true)
            dispatch({
                type: ACTIONS.SET_IDCLIENT,
                payload: idClient
            })
            setIdClient();
        }
    }, [idClient])

    React.useEffect(() => {
        if (state.detailClient) {
            setLoading(false)
            if (state.detailClient?.code === 0) {
                setDetailClientJson({...state.detailClient, idClient: state.idClientAux});
            } else {
                setDetailClientJson([])
                props.setGlobalAlert(state.detailClient?.mensaje ? state.detailClient?.mensaje : decode_utf8(props.text_fetch_error),"warning", true, "Advertencia");
                dispatch({
                    type: ACTIONS.SET_IDCLIENT,
                    payload: 0
                })
                setIdClient("");
                setValues({ ...values, numberClient: "" })
            }
        }
    }, [state.detailClient])

    React.useEffect(() => {
        if (detailClientJson) {
            setValues({ ...values, comuna: detailClientJson?.comuna, calle: detailClientJson?.calle, number: detailClientJson?.numero, dpto: `${detailClientJson?.dirDpto}` })
        }
    }, [detailClientJson])

    React.useEffect(() => {
        const ObjResponse = state.optionsMechanismsResponse;
        if(ObjResponse){
            if(ObjResponse?.code === 0 && ObjResponse?.tiposIntalacionesRe?.length > 0) {
                let arOptions = [{label: "Seleccione una opción", value: 0 }]
                const numCti = urlParams.get('cti');
                ObjResponse?.tiposIntalacionesRe?.map(obj => {
                    arOptions.push({ label: obj?.nombre, value: obj?.id });
                })
                if(numCti) {
                    const objVerif = arOptions.filter(function (obj) {
                        return obj.value === Number(numCti);
                    });
                    if(objVerif?.length > 0) {
                        setValueOption(Number(numCti));
                    }
                }
                setOptions(arOptions);
            } else {
                props.setGlobalAlert("El servicio no está disponible actualmente, intente más tarde.","warning", true, "Advertencia");
            }
        }
        
    },[state.optionsMechanismsResponse]);

    return (
        <CGE.Panel title={decode_utf8(props.title_reconversion_energetica)}>    
            <CGE.PanelSection title={decode_utf8(props.subtitulo_1_title_reconversion_energetica)}>
                <div className="row d-flex align-items-center">
                    <div className="col-md-12">
                        <CGE.DetailClient
                            props={{
                                handleChange: (e) => setValues({ ...values, numberClient: e.target.value }),
                                hasError: inputValidate?.empty?.numberClient || inputValidate?.empty?.comuna,
                                msgError: inputValidate?.msg?.numberClient?inputValidate?.msg?.numberClient:inputValidate?.msg?.comuna?inputValidate?.msg?.comuna:"",
                                idClient: values.numberClient,
                                idFormElement: "numberClient",
                                labelName: "Número de Cliente:",
                                placeholder: "Número de Cliente",
                                mandatoryElement: true,
                                valuePub: values.numberClient,
                                labelButton: "Buscar",
                                handleClick: () => { handleClickButtonClient() },
                                sizeButton: "sm",
                                typeButton: "primary",
                                propsLabelInfoContent:propsLabelInfoContent
                            }}
                            propsDetail={{
                                fullNameClient: (detailClientJson?.primerNombre || detailClientJson?.segundoNombre
                                    || detailClientJson?.apellido) ? values.socialReason = `${detailClientJson?.primerNombre} ${detailClientJson?.segundoNombre} ${detailClientJson?.apellido}` : "",
                                comunaClient: detailClientJson?.comuna ? detailClientJson?.comuna : "",
                                calleClient: detailClientJson?.calle ? detailClientJson?.calle : "",
                                nCalleClient: detailClientJson?.numero ? detailClientJson?.numero : "",
                                dptoBlockClient: `${detailClientJson?.dirDpto ? detailClientJson?.dirDpto : ""}`,
                                ctaCtoClient: detailClientJson?.idClient
                            }}
                        />
                    </div>

                </div>
            </CGE.PanelSection>
            <CGE.PanelSection title={decode_utf8(props.subtitulo_2_title_reconversion_energetica)}>
                <div className="row">
                    <div className="col-md-4">
                        <CGE.FormsField
                            placeholder="Rut (Ej: 12345678-9)"
                            labelName="Nº del carnet de identidad o RUT"
                            handleChange={({ target }) => {
                                setValues({ ...values, rut: target.value })
                            }}
                            idFormElement="inputRut"
                            typeFormElement="text"
                            mandatoryElement={true}
                            value={values.rut}
                            typeElement="input-mask"
                            beforeMaskedValueChange={beforeMaskedValueChangeRut}
                            formatChars={{
                                "9": "[0-9]",
                                k: "[Kk0-9]",
                            }}
                            mask="9.999.999-kk"
                            hasError={inputValidate?.empty?.rut || inputValidate?.error?.rut}
                            msgError={inputValidate?.msg?.rut}
                        />
                    </div>
                    <div className="col-md-4">
                        <CGE.FormsField
                            placeholder="Nombres"
                            mandatoryElement={true}
                            labelName="Nombres"
                            idFormElement="name"
                            handleChange={(e) => setValues({ ...values, name: e.target.value })}
                            typeFormElement="text"
                            typeElement="input"
                            value={values.name}
                            maxLength="40"
                            hasError={inputValidate?.empty?.name}
                            msgError={inputValidate?.msg?.name}
                        />
                    </div>
                    <div className="col-md-4">
                        <CGE.FormsField
                            placeholder="Apellido Paterno"
                            mandatoryElement={true}
                            labelName="Apellido Paterno"
                            idFormElement="nameFather"
                            handleChange={(e) => setValues({ ...values, nameFather: e.target.value })}
                            typeFormElement="text"
                            typeElement="input"
                            value={values.nameFather}
                            maxLength="40"
                            hasError={inputValidate?.empty?.nameFather}
                            msgError={inputValidate?.msg?.nameFather}
                        />
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-4">
                        <CGE.FormsField
                            placeholder="Apellido Materno"
                            mandatoryElement={true}
                            labelName="Apellido Materno"
                            idFormElement="nameMother"
                            handleChange={(e) => setValues({ ...values, nameMother: e.target.value })}
                            typeFormElement="text"
                            typeElement="input"
                            value={values.nameMother}
                            maxLength="40"
                            hasError={inputValidate?.empty?.nameMother}
                            msgError={inputValidate?.msg?.nameMother}
                        />
                    </div>
                    <div className="col-md-4">
                        <CGE.FormsField
                            placeholder="Email"
                            mandatoryElement={true}
                            labelName="Email"
                            idFormElement="email"
                            handleChange={(e) => setValues({ ...values, email: e.target.value })}
                            typeFormElement="text"
                            typeElement="input"
                            value={values.email}
                            maxLength="100"
                            hasError={inputValidate?.empty?.email || inputValidate?.error?.email}
                            msgError={inputValidate?.msg?.email}
                        />
                    </div>
                    <div className="col-md-4">
                        <CGE.FormsField
                            placeholder="Ej: 995048949"
                            mandatoryElement={true}
                            labelName="Celular o teléfono de contacto"
                            idFormElement="cel"
                            handleChange={(e) => setValues({ ...values, cel: e.target.value })}
                            typeFormElement="text"
                            value={values.cel}
                            typeElement="input-mask"
                            formatChars={{
                                "9": "[0-9]",
                            }}
                            mask="999999999"
                            maxLength="9"
                            hasError={inputValidate?.empty?.cel || inputValidate?.error?.cel}
                            msgError={inputValidate?.msg?.cel}
                        />
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-12">
                        <CGE.FormsField
                            handleChange={(e) => setValues({ ...values, desc_1: e.target.value })}
                            mandatoryElement={true}
                            idFormElement="desc1"
                            labelName="Equipos eléctricos a consecuencia de la reconversión energética y sus características técnicas (estufas, aire acondicionado y otros)"
                            placeholder="Describa aquí la marca, modelo y tipo de equipos usados al realizar la reconversión energética de su hogar, por ejemplo: Se reemplazo estufa a leña por 2 estufas (marca) oleoeléctricas de 1200 watts cada una y un equipo de aire acondicionado de 18.000 BTU (marca), adquiridos para este fin."
                            maxLength="400"
                            numberOfRows="4"
                            typeElement="textarea"
                            className="mb-0"
                            value={values.desc_1}
                            hasError={inputValidate?.empty?.desc_1}
                            msgError={inputValidate?.msg?.desc_1}
                        />
                    </div>

                </div>
                <div class="row pt-0 ">
                    <div className="col-md-12">
                        <CGE.Text
                            size="2"
                            text={
                                <>
                                    Quedan {400 - (values?.desc_1?.length ? values?.desc_1?.length : 0)} caracteres
                                </>
                            }
                        />
                    </div>
                </div>

                <div className="row">
                    <div className="col-md-12">
                        <CGE.FormsField
                            handleChange={(e) => setValues({ ...values, desc_2: e.target.value })}
                            mandatoryElement={true}
                            idFormElement="desc2"
                            placeholder="Suma de las potencias de los equipos eléctricos, expresada en KW, por ej. 5,5 KW"
                            labelName="Potencia total de los equipos eléctricos instalados en la reconversión energética"
                            maxLength="50"
                            numberOfRows="4"
                            typeElement="textarea"
                            className="mb-0"
                            value={values.desc_2}
                            hasError={inputValidate?.empty?.desc_2}
                            msgError={inputValidate?.msg?.desc_2}
                        />
                    </div>
                </div>
                <div class="row pt-0 ">
                    <div className="col-md-12">
                        <CGE.Text
                            size="2"
                            text={
                                <>
                                    Quedan {50 - (values?.desc_2?.length ? values?.desc_2?.length : 0)} caracteres
                                </>
                            }
                        />
                    </div>
                </div>
            </CGE.PanelSection>
            <CGE.PanelSection title={decode_utf8(props.subtitulo_3_title_reconversion_energetica)}>
                <div className="row">
                    <div className="col-md-12">
                        <CGE.FormsField
                            handleChange={(event) => setValues({ ...values, selectOptions: event.target.value })}
                            idFormElement="selectOptions"
                            labelName="¿Cuenta su vivienda con un sistema de medición independiente, sólo para los consumos de la reconversión energética?"
                            listOptions={options}
                            typeElement="select"
                            mandatoryElement={true}
                            typeFormElement="text"
                            disabled={valueOption?true:false}
                            value={valueOption?valueOption:values.selectOptions}
                            hasError={inputValidate?.empty?.selectOptions}
                            msgError={inputValidate?.msg?.selectOptions}
                        />
                    </div>
                </div>
            </CGE.PanelSection>
            <CGE.PanelSection title={decode_utf8(props.subtitulo_4_title_reconversion_energetica)}>
                <div className="row">
                    <div className="col-md-12">
                        <CGE.RenderContent textContent={state?.webContentTerminosCondiciones} />
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-12">
                        <CGE.CheckBoxGroup
                            labelNameCheckBoxGroup=""
                            mandatoryElement={true}
                            optionsGroup={[{
                                "checked": values.checkbox,
                                "handleChange": ({ target }) => setValues({ ...values, checkbox: !values.checkbox }),
                                "idFormElement": "acceptTerms",
                                "labelName": "Acepto los términos y condiciones",
                                "typeElement": "input",
                                "typeFormElement": "checkbox",
                                "value": values.checkbox,
                            },
                            ]}
                        />
                    </div>
                    <div className="col-md-12">
                        <CGE.FieldRecaptcha
                            onChange={onChangeReCaptcha}
                            sitekey={props.api_key_recaptcha}
                            mandatoryElement={true}
                        />
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-12 d-flex justify-content-end">
                        <CGE.Button
                            onClick={() => funcSend()}
                            label="Enviar"
                        />
                    </div>
                </div>
            </CGE.PanelSection>
            {loading && <Loading />}
        </CGE.Panel>
    );

}

const EnergyReconversionWithProvider = ({ props }) => (
    <EnergyReconversionContextProvider>
        <EnergyReconversion props={props} />
    </EnergyReconversionContextProvider>
);
export default EnergyReconversionWithProvider;
